import { Group, Quaternion, Vector3 } from "three";
import { MapConfig } from "./consts";
import { ImmovableBodyConfig } from "@managers/physics";
import { RigidBody } from "@objects/physics";
import Heightmap from "./heightmap";
import { PlaneMeshController } from "@controllers/mesh/simple/PlaneMeshController";
import { MeshShapeController } from "@objects/physics/shapes";
class Ground {
    position;
    rotation;
    dimensions;
    group;
    meshController;
    heightmap;
    rigidBody;
    static instance;
    /**
     * Ground object.
     * @param scene the rendering scene.
     * @param physicsWorld the physicsWorld.
     * @param assetLoader An object containing all the game's assets.
     * @throws Error if the heightmap is undefined.
     * @private
     */
    constructor(scene, physicsWorld, assetLoader) {
        const heightmap = assetLoader.getTerrainHeightmap?.image;
        const normalmap = assetLoader.getTerrainNormalmap;
        // heightmap.magFilter = LinearFilter;
        if (!heightmap)
            throw new Error("Ground could not be constructed: Heightmap image is undefined.");
        this.heightmap = new Heightmap(heightmap);
        this.position = new Vector3();
        this.rotation = new Quaternion();
        this.dimensions = new Vector3(MapConfig.GROUND_WIDTH, 1, MapConfig.GROUND_HEIGHT);
        this.meshController = new PlaneMeshController(MapConfig.COLOR, this.dimensions, MapConfig.SEGMENTS, MapConfig.GROUND_ROTATION, this.heightmap, normalmap, MapConfig.RECEIVE_SHADOW, MapConfig.CAST_SHADOW);
        this.group = this.createGroup();
        this.group.add(this.meshController.getMesh);
        this.rigidBody = new RigidBody(ImmovableBodyConfig, this.position, this.rotation, new MeshShapeController(), this.meshController);
        scene.add(this.group);
        physicsWorld.addRigidBody(this.rigidBody.getBody);
    }
    /**
     * Create a group object.
     * @returns the create group object.
     * @private
     */
    createGroup() {
        const group = new Group();
        group.position.copy(this.position);
        group.quaternion.copy(this.rotation);
        return group;
    }
    get getGroup() {
        return this.group;
    }
    static getInstance(scene, physicsWorld, assetLoader) {
        if (!Ground.instance)
            Ground.instance = new Ground(scene, physicsWorld, assetLoader);
        return Ground.instance;
    }
}
export { Ground };
